export type TagParams = {
  label: string
  bgColor: string
  textColor: string
  tooltip?: string
}

export enum UiTranslationStatus {
  COMPLETED = 'COMPLETED',
  UPLOADING = 'UPLOADING',
  STATUS_CHECK = 'STATUS_CHECK',
  EXPORTING_FILE = 'EXPORTING_FILE',
}
